import { Container, Box, Text, useToast, Icon, Flex } from '@chakra-ui/react';
import dayjs from 'dayjs';
import React, { useCallback } from 'react';
import { SlotInfo, Views } from 'react-big-calendar';
import { MdCalendarToday } from 'react-icons/md';
import { AppCalendar } from '../../components/common/AppCalendar';
import { useReservation } from './ReservationContext';

const ReservationCreateDate: React.FC = () => {
  const { goToNext } = useReservation();
  const toast = useToast();

  // 今日から60日先までの日付範囲を設定
  const today = dayjs().startOf('day');
  const sixtyDaysLater = dayjs().add(60, 'days').endOf('day');

  // カレンダースロット選択時のハンドラ
  const handleSelectSlot = useCallback((slotInfo: SlotInfo) => {
    const selectedDay = dayjs(slotInfo.start).startOf('day');
    
    // 選択可能な日付範囲内かチェック
    if (selectedDay.isBefore(today)) {
      toast({
        title: '過去の日付は選択できません',
        status: 'info',
        duration: 3000,
        isClosable: true,
        position: 'top',
      });
      return;
    }
    
    if (selectedDay.isAfter(sixtyDaysLater)) {
      toast({
        title: '60日以上先の日付は選択できません',
        status: 'info',
        duration: 3000,
        isClosable: true,
        position: 'top',
      });
      return;
    }
    
    // 日付を選択したら、その情報を更新して自動的に次の画面へ遷移
    const formattedDate = selectedDay.format('YYYY-MM-DD');
    goToNext({ date: formattedDate });
  }, [today, sixtyDaysLater, goToNext, toast]);

  return (
    <Container maxW="container.md" mt={4}>
      <Box>
        <Flex alignItems="center" gap="8px" mb={4}>
          <Icon as={MdCalendarToday} boxSize="20px" color="gray.700" />
          <Text color="gray.600">
            1.日時を選択してください。（予約は本日から60日先まで可能です。）
          </Text>
        </Flex>
        
        <Box mb={6}>
          <AppCalendar
            events={[]}
            selectable="ignoreEvents"
            onSelectSlot={handleSelectSlot}
            defaultViewDate={today.toDate()}
            views={[Views.MONTH]}
          />
        </Box>
      </Box>
    </Container>
  );
};

export default ReservationCreateDate; 